/* eslint-disable */
export default {
  matched: '符合項目',
  other: '其他',
  associated: '已關聯項目',
  foundFromServer: '在 {appName} 中找到',
  recently: '最近',
  additionalLabelAccount: '帳戶：{displayName}',
  additionalLabelContact: '連絡人：{displayName}',
  notFound: '無',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
